import { AbstractControl, ValidationErrors } from '@angular/forms';

import { SpecialValidationType } from '@app/origami-api/constants/validation-type';
import { RangeOptions } from '@app/shared/forms/dynamic-form/fields.service';
import { SpecialValidatorFnFactory } from '@app/shared/utils/special-validators/special-validators.model';

export const createRangeValidator: SpecialValidatorFnFactory = function (options: RangeOptions) {
  return function (control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    let result = false;

    if (value && options && options.from && options.to) {
      result = value >= options.from && value <= options.to && value.length === options.to.length;
    }

    return result || !value ? null : { [SpecialValidationType.Range]: { value } };
  };
};
